import React, { useState, useEffect, FC } from "react";
import Content from "../../layout/content/Content";
import { Card } from "reactstrap";
import Head from "../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
} from "../../components/Component";
import { Steps, Step } from "react-step-builder";
import { useForm, FormProvider } from "react-hook-form";
import RFQHeader from "./newBudgets/BudgetHeader";
import { FormDataProvider } from "./newBudgets/FormDataContext";
import BudgetMaterials from "./newBudgets/BudgetMaterials";
import BudgetGeneralDetails from "./newBudgets/BudgetGeneralDetails";
import BudgetOthers from "./newBudgets/BudgetOthers";
import BudgetPreview from "./newBudgets/BudgetPreview";
import { Link } from "react-router-dom";
const config = {
  before: RFQHeader as React.ComponentType<{}> as () => React.ReactElement,
};

const BudgetCreation: FC = () => {
  const [sm, setSm] = useState(false);
  const [mobileView, setMobileView] = useState(false);
  const formMethods = useForm({ mode: "onChange" });

  const viewChange = () => {
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };

  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);


  return (
    <FormDataProvider>
      <Head title="Budget - Create New" />
      <Content>
        <Card className="card-bordered" style={{ overflowX: "clip", maxWidth: "100%" }}>
          <div className="card-aside-wrap" style={{ minWidth: 0, maxWidth: "100%" }}>
            <div className="card-inner card-inner-lg" style={{ minWidth: 0, maxWidth: "100%", overflowX: "clip" }}>
              {sm && mobileView && (
                <div
                  className="toggle-overlay"
                  onClick={() => setSm(!sm)}
                ></div>
              )}
              <BlockHead size="lg">
                <BlockBetween>
                  <BlockHeadContent>
                    <BlockTitle tag="h4">{"New Budget"}</BlockTitle>
                  </BlockHeadContent>
                  <Link to={`${process.env.PUBLIC_URL}/view-budget`}>
                    <Button
                      outline
                      className="bg-white d-none d-sm-inline-flex"
                    >
                      <Icon name="arrow-left"></Icon>
                      <span>Back</span>
                    </Button>
                    <Button
                      outline
                      className="btn-icon bg-white d-inline-flex d-sm-none"
                    >
                      <Icon name="arrow-left"></Icon>
                    </Button>
                  </Link>
                  <BlockHeadContent className="align-self-start d-lg-none">
                    <Button
                      className={`toggle btn btn-icon btn-trigger mt-n1 ${
                        sm ? "active" : ""
                      }`}
                      onClick={() => setSm(!sm)}
                    >
                      <Icon name="menu-alt-r" />
                    </Button>
                  </BlockHeadContent>
                </BlockBetween>
              </BlockHead>
              <Block className="mt-1">
                <div
                  className="nk-wizard nk-wizard-simple is-alter wizard clearfix"
                  style={{ minWidth: 0, maxWidth: "100%", overflowX: "clip" }}
                >
                  <FormProvider {...formMethods}>
                    <Steps config={config}>
                      <Step component={BudgetGeneralDetails} />
                      <Step component={BudgetMaterials} />
                      <Step component={BudgetOthers} />
                      <Step component={BudgetPreview} />
                    </Steps>
                  </FormProvider>
                </div>
              </Block>
            </div>
          </div>
        </Card>
      </Content>
    </FormDataProvider>
  );
};

export default BudgetCreation;
